import { isDate, mapValues } from 'lodash-es'

export function useQueryParams<
  T extends object,
  R extends {
    [K in keyof T as T[K] extends Falsy ? never : K]: Exclude<T[K], Falsy>
  },
>(source: MaybeRefOrGetter<T>) {
  return computed(() => {
    const mappedParams = mapValues(toValue(source), toQueryValue)
    return sortKeys(removeEmpty(mappedParams)) as unknown as R
  })
}

function toQueryValue<T>(value: T) {
  return isDate(value) ? toServerDate(value) : value
}
